import {DG_axios} from "../../../../../custom/axios";
import {DG_axiosNormal} from "../../../../../custom/axios/normal";

const url = `/dogoo/shiftwork-rest/v2.0/shiftWorkSchedules`;
const BASE_URI = `/dogoo/shiftwork-rest/v2.0/shiftworks`;
export const loadShiftWorksApi = async(id) => {
    const response = await DG_axios.get(BASE_URI + "/" + id);

    return response.data || []
};

export const loadShiftWork = async(params) => {
    const config = {params: params};
    const response = await DG_axios.get(BASE_URI, config);

    return response.data || []
};

export const addShiftWorkApi = async(shiftworks) => {
    const response = await DG_axios.post(BASE_URI, shiftworks);

    return response.data || []
};

export const deleteShiftWorkApi = async(id) => {
    const response = await DG_axios.delete(
        BASE_URI,{  params: {
                id
            }}
        );

    return response.data || []
};
export const approvalShiftWorkApi = async(data, id) => {
    const response = await DG_axiosNormal.post(`${BASE_URI + "/approval"}?${id}`, data);

    return response.data || []
};

export const updateShiftWorkApi = async(id, shiftWork) => {
    const response = await DG_axios.put(BASE_URI + "/" + id, shiftWork);

    return response.data || []
};

export const  loadTimeEnginesApi = async(params) => {
    const config = {params: params};

    const response = await DG_axios.get(`${url}`,config)
    return response?.data || []
}


